var _style, _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreciosGasolineras12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 25",
    style: {
      enableBackground: "new 0 0 27 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000163061546659820616620000006000532533994057150_);}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.463;stroke-miterlimit:3.7037;}\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1,
    y: 0.5,
    width: 25,
    height: 24.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014627587529978549330000012867516171617008827_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_131_00000122700365624694722340000016272659382158108308_",
    style: {
      clipPath: "url(#SVGID_00000014627587529978549330000012867516171617008827_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80_00000085973327146696933480000008632323254432980106_",
    className: "st1",
    d: "M1,24.5c0.2-0.4,0.6-0.6,1-0.5 c0.7,0,1.3,0,2,0V1.9c-0.3,0-0.5,0-0.8,0C2.8,2,2.5,1.7,2.4,1.3c0,0,0-0.1,0-0.1c0-0.4,0.3-0.7,0.7-0.7c0,0,0.1,0,0.1,0H20 c0.4-0.1,0.8,0.2,0.8,0.6c0,0,0,0.1,0,0.1c0,0.4-0.3,0.7-0.7,0.7c0,0-0.1,0-0.1,0c-0.3,0-0.5,0-0.8,0v16.7c1,0.2,2-0.4,2.3-1.4 c0-0.2,0.1-0.4,0-0.5c0-3.5,0-6.9,0-10.4c0-0.6,0.3-0.9,0.9-0.9H23V5c0-0.7,0-1.4,0-2.1c0-0.3,0.1-0.6,0.3-0.7 c0.5-0.5,0.9-0.9,1.4-1.4c0.3-0.3,0.7-0.4,1-0.1c0,0,0,0,0.1,0.1c0.3,0.3,0.3,0.8,0,1.1c0,0,0,0-0.1,0c-0.4,0.4-0.7,0.7-1.1,1.1 c-0.1,0.1-0.1,0.2-0.1,0.2c0,0.7,0,1.4,0,2.1c0,0,0,0.1,0,0.1c0.2,0,0.5,0,0.7,0C25.6,5.3,26,5.6,26,6c0,0,0,0.1,0,0.1 c0,1.1,0,2.1,0,3.2c0,0.3-0.1,0.6-0.4,0.8c-0.8,0.7-1.6,1.3-2.4,2c-0.1,0.1-0.2,0.3-0.2,0.4c0,1.4,0,2.7,0,4.1 c0.1,1.8-1.4,3.4-3.2,3.4c-0.1,0-0.1,0-0.2,0h-0.4V24h2.2c0.4,0,0.7,0.2,0.8,0.6c0.1,0.4-0.1,0.7-0.5,0.8c0,0,0,0,0,0H1.5 c-0.2-0.1-0.4-0.3-0.5-0.5V24.5z M5.5,24h12.3V13.2H5.5V24z M17.8,1.9H5.5v9.7h12.3V1.9z M23.1,6.9v3.5c0.3-0.3,0.6-0.6,1-0.8 c0.3-0.2,0.5-0.6,0.5-1c0-0.6,0-1.1,0-1.7L23.1,6.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_82_00000012437295938126280590000010019458798727243449_",
    className: "st1",
    d: "M11.7,3.4h3.8 c0.4-0.1,0.8,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2c0,1.7,0,3.4,0,5.1c0.1,0.4-0.2,0.8-0.6,0.8c-0.1,0-0.1,0-0.2,0H7.8 C7.4,10.3,7,10,7,9.6c0-0.1,0-0.1,0-0.2c0-1.7,0-3.4,0-5.2C6.9,3.8,7.2,3.4,7.6,3.4c0.1,0,0.1,0,0.2,0C9.1,3.4,10.4,3.4,11.7,3.4  M14.9,4.9H8.4v3.9h6.4L14.9,4.9z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.6,21.3c0.4-0.3,0.7-0.6,0.8-1h1.2c-0.3,0.7-0.7,1.3-1.3,1.6c-0.6,0.4-1.3,0.6-2.1,0.6s-1.6-0.3-2.2-0.7 c-0.7-0.4-1.1-1.1-1.3-1.8h-1v-0.7h0.8c0-0.2,0-0.3,0-0.6c0-0.2,0-0.3,0-0.5H7.7v-0.6h1c0.2-0.5,0.4-0.9,0.8-1.3 c0.3-0.4,0.8-0.7,1.3-0.9c0.5-0.3,1-0.3,1.5-0.3c0.8,0,1.5,0.2,2.1,0.6s1,0.9,1.3,1.7h-1.2c-0.2-0.4-0.5-0.8-0.8-1 c-0.4-0.3-0.8-0.3-1.3-0.3c-0.6,0-1.1,0.2-1.5,0.4c-0.4,0.3-0.8,0.8-0.9,1.3h2.5v0.7H9.7c0,0.2,0,0.3,0,0.5s0,0.4,0,0.6h2.6V20 H9.8c0.2,0.5,0.5,0.9,0.9,1.2c0.4,0.3,0.9,0.4,1.5,0.4C12.8,21.6,13.2,21.4,13.6,21.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreciosGasolineras12);
export default __webpack_public_path__ + "static/media/precios-gasolineras-1 2.9ecdc5eea4bfacf2cf7dfbd6d8abe492.svg";
export { ForwardRef as ReactComponent };